import template from './mercuryButton.template.html';

export default {
  template,
  bindings: {
    currentTicket: '<',
    isSidebarMinimized: '<',
    onFinished: '&'
  },
controller: class controller {
    constructor($rootScope, $mdDialog, $mdMedia, ticketService, mercuryService, uiService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.isCreatingMercuryOpportunity = false;
      ctrl.mdMedia = $mdMedia;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentTicket = ctrl.currentTicket || {};
        ctrl.isSidebarMinimized = ctrl.isSidebarMinimized || false;
      };

      /*
       * Home loan ~ Mercury
       * --------------------------------------------------------------------------------
       */
      ctrl.mercuryConnect = () => {
        if (!ctrl.currentTicket.integrations.mercuryId) {
          ctrl.isCreatingMercuryOpportunity = true;
          uiService.toast({
            text: {
              p1: 'Creating Opportunity in Mercury',
              p2: ctrl.currentTicket.getName(),
              p3: 'please wait...'
            },
            warn: true
          });
          mercuryService.connect({ idTicket: ctrl.currentTicket.id }).then((result) => {
            ctrl.isCreatingMercuryOpportunity = false;
            if (result.status) {
              ctrl.currentTicket.integrations.mercuryId = result.mercuryId;
              uiService.toast({
                text: {
                  p1: 'Successfully created Opportunity',
                  p2: ctrl.currentTicket.getName(),
                  p3: 'in Mercury'
                },
                success: true
              });
            } else {
              uiService.toast({
                text: {
                  p1: 'Cannot create Opportunity',
                  p2: 'Error:',
                  p3: result.errorMessage
                },
                warn: true
              });
            }
          });
        } else {
          uiService.toast({
            text: {
              p1: 'Disconnecting',
              p2: ctrl.currentTicket.getName(),
              p3: 'from Mercury.'
            },
            warn: true
          });
          ticketService
            .updateTicket({ id: ctrl.currentTicket.id, integrations: { mercuryId: '' } })
            .then(() => {
              uiService.toast({
                text: {
                  p1: 'Successfully disconnected',
                  p2: ctrl.currentTicket.getName(),
                  p3: 'from Mercury.'
                },
                warn: true
              });
              ctrl.currentTicket.integrations.mercuryId = '';
            });
        }
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
